// START IMPORTS
// Theme and UI imports
import { BrandThemeProvider } from '@ltvco/refresh-lib/theme';
// Utility imports
import { useScreenSize } from '@ltvco/refresh-lib/utils';
// Core lib v1 imports
import { GrowthbookWrapper, useSession } from '@ltvco/refresh-lib/v1';
// Vendor imports
import { useState, useEffect } from 'react';

// App-specific imports
import { theme } from 'theme';
// END IMPORTS

export function Growthbook({ children }: { children: JSX.Element }) {
  // START HOOKS_AND_QUERIES
  const {
    session: { account },
  } = useSession();

  const { isMobile } = useScreenSize();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [customAttributes, setCustomAttributes] = useState<
    Record<string, unknown>
  >({});
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const deviceType = isMobile ? 'web-mobile' : 'web-desktop';
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    if (!account) return;
    setCustomAttributes({
      'rf-device-type': deviceType,
      'rf-brand-id': 'peoplesmart-refresh',
    });
  }, [account]);
  // END EFFECTS

  // START RENDER
  return (
    <GrowthbookWrapper
      enableDevMode={true}
      apiHost={'https://gbbv.beenverified.com'}
      clientKey={'sdk-sH9Cly3zfuFM9mdc'}
      decryptionKey={'nZwGIW+xki4yOM6qBBx8Kg=='}
      subscribeToChanges={false}
      customAttributes={customAttributes}
      brandName={'peoplesmart'}
    >
      <BrandThemeProvider theme={theme}>{children}</BrandThemeProvider>
    </GrowthbookWrapper>
  );
  // END RENDER
}
